import React, { Component } from 'react';
import commonDataStore from 'logic/Izenda.ReportDesignerCommonDataStore';
import {
  FIELD_FUNCTION_MODE
} from 'logic/data/Izenda.ReportPartFieldConstants';

class ContextMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuItems: [{
        name: 'Sort Up'
      }, {
        name: 'Sort Down'
      }, {
        name: 'Unsort'
      }]
    }
  }

  componentDidUpdate(prevProps) {

  }

  getFunctions = (querySourceId, dataFieldType) => {
    let uiState = {};
    commonDataStore
      .loadReportFunction(
        FIELD_FUNCTION_MODE.FieldProperty,
        dataFieldType,
        uiState.tenantId,
        [querySourceId]
      )
      .then((data) => {
        this.setState({menuItems: data})
      });
  }

  handleActionClick = (action) => {
    if(action.name === 'Sort Up') {
      this.handleSortReport('ASC');
    }

    if(action.name === 'Sort Down') {
      this.handleSortReport('DESC');
    }

    if(action.name === 'Unsort') {
      this.handleSortReport("");
    }
  }

  handleSortReport = (sortValue) => {
    const { needUpdatePreview, cellInfor, reportPart, previewRecords } = this.props;
    let { field, element } = cellInfor;
    let { reportPartContent } = reportPart;
    element.properties.setSortValue(sortValue);
    needUpdatePreview(reportPart, null, null, null, null, previewRecords);
  }

  render() {
    const {
      item,
      isVisible,
      mouseEvent
    } = this.props;

    const {
      menuItems
    } = this.state;

    const contextMenuStyle = {
      'top': mouseEvent && mouseEvent.clientY || 0,
      'left': mouseEvent && mouseEvent.clientX || 0
    };

    const isOpenClass = isVisible ? ' is-open' : '';

    return (
      <ul className={`izenda-context-menu${isOpenClass}`} style={contextMenuStyle}>
        {menuItems.map((item) =>
          <li key={item.name} className={item.name} onClick={() => this.handleActionClick(item)}>{item.name}</li>)}
      </ul>
    );
  }
}

export default ContextMenu;



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.ContextMenu.jsx